import React from "react";

class UploadFileButton extends React.Component {
  render() {
    return (
      <div className="btn">
        <label for="upload">{this.props.buttonText}</label>
        <input
          type="file"
          id="upload"
        />
      </div>
    );
  }
}

export default UploadFileButton;
